import axios from "axios";
import { utmBaseUrl } from "../helpers/constants";

export const addIssue = ({ token, payload }) => {
    return axios.post(`${utmBaseUrl}/v1/api/utm/report/${payload.droneId}`, payload, {
        headers: { "x-access-token": token },
    });
}
export const getAllIssues = ({ queryKey }) => {
    // console.log(queryKey[1], "token");
    return axios.get(`${utmBaseUrl}/v1/api/utm/report`, {
        headers: { "x-access-token": queryKey[0] },
    });
};

export const getIssueDetails = (issueId, token) => {
    return axios.get(`${utmBaseUrl}/v1/api/utm/report/${issueId}`, {
        headers: { "x-access-token": token },
    })
}